<template>
    <div>
        <b-row class="flex justify-center">
            <b-col
                v-for="(saleChannel,index) in salesChannels"
                :key="index"
                cols="12"
                md="3"
                class="mb-3"
            >
                <b-form-group :label="saleChannel.name" label-for="agency-select">
                <b-form-select
                    v-model="saleChannel.matchedSelected.id"
                    :options="$root.auxVars.salesChannelsOpts"
                    @change="updateSelected(saleChannel)"
                ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
    props: {
        salesChannels: {
            type: Array,
            required: true,
        }
    },
    methods: {
        updateSelected() {},
    },
    mounted(){
        this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ['salesChannelsOpts']
		});
    }
};
</script>
